// Components
const ModalPreviewReportedContent = () => import(/* webpackPrefetch: true, webpackChunkName: "modal-preview-reported-content"*/ '@/app/views/main-view/social-club/components/modals/modal-preview-reported-content/modal-preview-reported-content.vue');

// Mixins
import { tableMixins } from '@/app/mixins/utils/table-mixins.js';
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';
import { dateMixins } from '@/app/mixins/utils/date-mixins.js';
import { inputTextMixins } from '@/app/mixins/utils/input-text-mixins';

// Services
import ClubService from '@/app/services/main/club/club-service.js';

// Constants
import { STATUS_CODES } from '@/app/constants/status-constants';
import { CONTENT_STATUS } from '@/app/constants/status-constants';

export default {
	name: 'SocialClubAdmin',
	components: {
		ModalPreviewReportedContent
	},
	mixins: [ tableMixins, toastMessageMixins, dateMixins, inputTextMixins ],
	data() {
		return {
			isAPILoading: true,
			// table
			theads: [
				{ name: 'Reporter', searchLabel: 'f_reporter', sortLabel: 'reporter', isDesc: false, hasSearch: true, style: null},
				{ name: 'Content Type', searchLabel: 'f_contentType', sortLabel: 'contentType', isDesc: false, hasContentTypeSearch: true, style: 'min-width: 120px'},
				{ name: 'Date and Time Reported', sortLabel: 'createdAt', isDesc: false, style: null},
				{ name: 'Reason', sortLabel: 'reason', isDesc: false, style: null},
				{ name: 'Status', searchLabel: 'f_status', sortLabel: 'status', isDesc: false, hasStatusSearch: true, style: 'min-width: 120px'},
			],
			desc: true,
			// filter
			contentTypeList: ['POST','COMMENT'],
			statusList: [{id: 'PENDING', name: 'Pending Request'}, {id: 'ACTIVE', name: 'Removed Content'}, {id: 'INACTIVE', name: 'Remained Content'}],
		}
	},
	created() {
		this.getTableContent();
    },
    computed: {
        getActiveGroup() {
            return this.$store.getters.getActiveGroup;
        }
    },
	methods: {
		showPendingModal(content) {
			// show modal and pass content for reported preview
			this.$refs.modalPreviewContent.setContent(content, this.getActiveGroup.id);
		},
		getTableContent(fromFilter, page = this.page, limit = this.limit, sortBy = this.sortBy, desc = this.desc) {
			page = fromFilter ? 1 : this.page;
			this.getReportedList({ page, limit, sortBy, desc });
		},
		getReportedList(queryParams) {
			// search filters
			if (this.columnsFilter) {
				if (this.columnsFilter.f_reporter) {
					queryParams['f_reporter'] = this.columnsFilter.f_reporter; 
				}

				if (this.columnsFilter.f_contentType) {
					queryParams['f_contentType'] = this.columnsFilter.f_contentType; 
				}

				if (this.columnsFilter.f_status) {
					queryParams['f_status'] = this.columnsFilter.f_status; 
				}
			}

            this.isAPILoading = true;
            
			// Call API service to get the table content
			ClubService.getAdminReported(this.getActiveGroup.id, queryParams)
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.tableContent = {
							tableData: res.data.data,
							paginationData: res.data.pagination
						};
					} else {
						const { ERROR_GET_REPORTED_LIST } = this.toastMessages.report();
						this.showAPIErrorToast(ERROR_GET_REPORTED_LIST, res);
					}
					this.isAPILoading = false;
				})
				.catch(() => {
					this.showGenericErrorToast();
					this.isAPILoading = false;
				});
		},
		getClassByStatus(status) {
			switch (status) {
				case CONTENT_STATUS.APPROVED: {
					return 'badge-danger';
				}
				case CONTENT_STATUS.DISAPPROVED: {
					return 'badge-success';
				}
				case CONTENT_STATUS.PENDING: {
					return 'badge-primary';
				}
			}
		},
		showCreateGroupModal() {
            // Open create group modal under social club admin component
            this.$emit('showCreateGroupModal');
        }
    }
}